import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  image: string;
  author: string;
  date: string;
  readTime: string;
  category: string;
  categoryName: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  image,
  author,
  date,
  readTime,
  category,
  categoryName,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer">
      <Link to={`/article/${slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute top-3 left-3">
            <Link
              to={`/category/${category}`}
              className="text-xs font-medium px-2.5 py-1 rounded-full bg-background-50/90 text-primary-500 backdrop-blur-sm whitespace-nowrap cursor-pointer"
            >
              {categoryName}
            </Link>
          </div>
        </div>
        <div className="p-5">
          <h3 className="text-base font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
            {title}
          </h3>
          <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
            {excerpt}
          </p>
          <div className="mt-4 flex items-center justify-between text-xs text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {author}
            </span>
            <div className="flex items-center gap-3">
              <span>{date}</span>
              <span className="flex items-center gap-1">
                <i className="ri-time-line"></i>
                {readTime}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}